
import React from 'react';
import { Avatar } from '@/components/ui/avatar';

interface VideoHeaderProps {
  profileName?: string;
}

const VideoHeader: React.FC<VideoHeaderProps> = ({ profileName = "Unknown Channel" }) => {
  return (
    <div className="p-4 flex items-center border-b dark:border-gray-700/50 dark:bg-[#252A41]">
      <Avatar className="h-8 w-8 mr-3">
        <div className="bg-gray-200 dark:bg-gray-700 w-full h-full flex items-center justify-center text-gray-500 dark:text-gray-300 text-xs font-bold">
          {profileName.charAt(0).toUpperCase()}
        </div>
      </Avatar>
      <span className="text-sm font-medium dark:text-gray-200">{profileName}</span>
    </div>
  );
};

export default VideoHeader;
